import React, { Component, useEffect, useRef, useState } from "react";
import CardContainer from "pages/components/CardContainer";
import { connect } from "react-redux";
import { Checkbox, Grid, MenuItem, styled, TableCell } from "@material-ui/core";
import CustomNewTable, { TABLE_COLUMN_IDS } from "pages/components/NewTable";
import {
  DEFAULT_VALUES,
  REFILL_MANAGEMENT_STATUS,
  DESC,
  PURCHASE_ORDER_STATUSES,
} from "../../../../constants";
import { getDateAndTime, objectHasKeysCheck, webApiCheck } from "services/commonMethods";
import RedirectToView from "pages/components/RedirectToView";
import Breadcrumbs from "pages/components/Breadcrumbs";
import { breadcrumbsMapping } from "services/breadcrumbsMapping";
import {
  requestMaterialTransfer,
  resetMaterialTransferOrder,
} from "modules/actions/materialTransferView.action";
import { API_ROUTES, API_ROUTES_KEY } from "constants/apiRoutes";
import { API_ACTIONS, getPayloadData } from "constants/apiRequestData";
import CustomAutoComplete from "pages/components/AutoComplete";
import NewCustomToggle from "pages/components/NewToggle";
import CustomInput from "pages/components/Input";
// import scannerIcon from "assets/icons/ph_barcode.svg";
import scannerIcon from "assets/icons/red_Scanner.svg";
import '../warehouse_crud.scss'
import EditForm from "pages/components/Modals/EditForm";
import ViewButtons from "pages/components/ViewButtons";
import CrossIcon from "assets/icons/cross_icon.svg";
import { ROUTES_WITH_INLINE_PARAMS } from "constants/appRoutes";
import CustomButton from "pages/components/Button";
import { postDashboardWebApi } from "webApis/apiResource";
import { getAccessToken } from "services/browserStorage";
import { successToast } from "modules/actions/toast.action";

function MaterialTransferMangeView({
    materialTransferView,
    requestMaterialTransfer,
    resetMaterialTransferOrder,
    match,
    history,
    successToast,
    location,
    me,
}){
 
    const DEFAULT_ORDER_STATUS=PURCHASE_ORDER_STATUSES.CREATED
   const [tableData, setTableData]=useState([])
   const [updatedOrder, setUpdatedOrder]=useState([])
   const [orderContainer, setOrderContainer]=useState([])
   const [dropdownSelectedProduct, setDropdownSelectedProduct]=useState(null)
   const [scanItemsToggle, setScanItemsToggle]=useState(false)
   const [showPartialModal, setShowPartialModal]=useState(false)
   const [showCancelModal, setShowCancelModal] = useState(false);
   const [popupInputCheck, setPopupInputCheck] = useState(false);
   
   const [currentOrderStatus, setCurrentOrderStatus] =
    useState(DEFAULT_ORDER_STATUS);

    const handleTableHeadCheckbox = function (ev) {
      const isChecked = ev.target.checked;
      setOrderContainer((prev) =>
        prev?.map((obj) => {
          if (isChecked) {
            // Toggle isChecked based on the current value
            return { ...obj, isChecked: true };
          }
          // Return the object as is if it's not the clicked item
          return  { ...obj, isChecked: false };
        })
      );
    
  
    };

    const handleRowCheckbox = (ev, item) => {
      const isChecked = ev.target.checked;
      setOrderContainer((prev) =>
        prev?.map((obj) => {
          if (obj.id === item.id) {
            // Toggle isChecked based on the current value
            return { ...obj, isChecked: isChecked ? !obj.isChecked : false };
          }
          // Return the object as is if it's not the clicked item
          return obj;
        })
      );
    };


    const onChangeHandler = (event, id, product_id) => {
      const { name, value } = event.target;
      if(orderContainer?.length>0 && orderContainer ){
      setOrderContainer((prevData) =>
        prevData.map((item) =>
          // item.product_id === product_id ? { ...item, [name]: parseInt(value) } : item
          item.product_id === product_id ? { ...item, received_stock: parseInt(value) } : item
        )
      );
  
      // Update the updatedValues array with only the changed values
      setUpdatedOrder((prevUpdates) => {
        const existingUpdateIndex = prevUpdates.findIndex((item) => item.product_id === product_id);
  
        if (existingUpdateIndex !== -1) {
          // Update the existing entry
          const updatedArray = [...prevUpdates];
          updatedArray[existingUpdateIndex] = { "product_id":product_id, "received_stock": parseInt(value) };
          return updatedArray;
        } else {
          // Add a new entry if it doesn't exist
          return [...prevUpdates, { "product_id":product_id, "received_stock": parseInt(value) }];
        }
      });
    }
    };

    const MATERIAL_ORDER_STATUSES = {
      // DELIVERED: { id:1, key: "DELIVERED", displayText: "Delivered", displayColor: "#3987FD" },
      CANCELLED: {
        id:2,
        key: "CANCELLED",
        displayText: "Cancelled",
        displayColor: "#FF2E43",
      },
      RECEIVED: {
        id:3,
        key: "RECEIVED",
        displayText: "Received",
        displayColor: "#4CB04E",
      },
      PARTIALLY_RECEIVED: {
        id:4,
        key: "PARTIALLY_RECEIVED",
        displayText: "Partially Received",
        displayColor: "#FFC41E",
      },
    };


    const tableHeadChangeOrder = [
      {
        title: "Product SKU",
      },
      {
        title: "Product Name",
      },
      {
        title: "Category",
      },
      {
        title: "Transfer Qty.",
      },
      {
        title: "Current Stock",
      },
      {
        title: "Price",
      },
      {
        title: "Partial Transfer Qty.",
      },
      {
        title:   
        <Checkbox
        checked={   orderContainer?.length > 0 &&
          orderContainer.every((order) => order.isChecked)}

        value={   orderContainer?.length > 0 &&
          orderContainer.every((order) => order.isChecked)}
        size="small"
        classes={{
          root: "permission-checkbox",
          checked: "permission-checkbox-checked",
        }}
        onChange={handleTableHeadCheckbox}
      />,
      },
     
    ];
    const tableHead = [
      {
        title: "SKU",
      },
      {
        title: "Name",
      },
      {
        title: "Categopry",
      },
      {
        title: "Price",
      },
      {
        title: "Status",
      },
      {
        title: "Old Stock",
      },
      {
        title: "Stock Transferred",
      },
    ];
  

  useEffect(()=>{
    let endPointUrl = API_ROUTES[API_ROUTES_KEY.GET_MATERIAL_TRANSFER];
    let payload= getPayloadData(API_ROUTES_KEY.GET_MATERIAL_TRANSFER, false, {
         id: parseInt(match.params.id) 
        })
    requestMaterialTransfer(endPointUrl,payload);

    return () => {
      resetMaterialTransferOrder(); // Reset the order when component unmounts
    };
  },[]) 

  useEffect(()=>{
    currentOrderStatus?.key!==MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key && setScanItemsToggle(false)
    if (materialTransferView.id && currentOrderStatus?.key!==MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key) {
      materialTransferView.ShippingDetails.forEach((obj)=>{
        obj.received_stock=obj.stock
      })
      setOrderContainer(materialTransferView.ShippingDetails)
      }
      

  },[materialTransferView,currentOrderStatus]) 

  useEffect(()=>{
    const dropDownProduct=materialTransferView.ShippingDetails?.filter((obj)=>{
      return dropdownSelectedProduct? obj?.id!==dropdownSelectedProduct?.id:obj
    })


    let temp = [];
    let addCustomRow ={
      sku:(
        <TableCell colSpan={2}>
        {" "}
        <div style={{display:"flex", alignItems:"flex-end", justifyContent:"center"}}>
        <CustomAutoComplete
                autoCompleteProps={{
                  id: "selectedProduct",
                  options: dropDownProduct,
                  fullWidth: true,
                  freeSolo:false,
                  name: "dropDownProduct",
                  value: dropdownSelectedProduct,
                  // value: "",
                  onChange: handleDropdownSelectedProduct,
                  getOptionLabel: (option) =>
                  option && option.Product.name ?  `${option.Product.name} - ${option.Product.sku}` : "", 
                  filterOptions: (options, { inputValue }) =>
                    options.filter(
                      (option) =>
                        option.Product.sku.toLowerCase() === inputValue.toLowerCase()
                    ),
                  openOnFocus: true,
                  // ref: inputRef,
                  required: true,
                  style: {
                    width: "97%",
                  },
                }}
                textFieldProps={{
                  label: "Select Product",
                  className: "input-add-screen mt-3",
                  variant: "outlined",
                  size: "small",
                  // required: true,
                }}
              />
              
          <label style={{margin:"0", padding:"0", cursor:"pointer"}} htmlFor="selectedProduct"><img  style={{width:"45px"}} src={scannerIcon} alt="scanner" /></label>
          </div>
      </TableCell>
      ),
      category: <TableCell></TableCell>,
      transfer_qty: <TableCell></TableCell>,
      stock: <TableCell></TableCell>,
      price: <TableCell></TableCell>,
      partial_qty: <TableCell></TableCell>,
      checkbox: <TableCell></TableCell>,
    }
    if(scanItemsToggle==true &&currentOrderStatus?.key==MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key){temp.push(addCustomRow)}
    // if(scanItemsToggle==true){setMaterialTableDataEdit(temp)}
    if(scanItemsToggle==true&&currentOrderStatus?.key==MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key){setTableData(temp)}

      if(orderContainer?.length>0){
        let totalOldStock = 0;
        // let totalReturnedStock = 0;

        orderContainer?.forEach((item) => {
          let json = {};
          json["sku"] = (
            <RedirectToView redirectToView={() => {}}>
              {item?.Product?.sku || DEFAULT_VALUES.DOUBLE_DASH}
            </RedirectToView>
          );
          json["name"] = (
            <TableCell className="ellipsis">
              <span>{item?.Product?.name || DEFAULT_VALUES.DOUBLE_DASH}</span>
            </TableCell>
          );
          json["category"] = (
            <TableCell className="ellipsis">
              <span
                style={{
                  color: "#F95A3F",
                  cursor: "pointer",
                }}
                onClick={() => {}}
              >
                {
                  item?.Product?.ProductCategory.name ||
                  DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          );
          json["transfer_qty"] = (
            <TableCell>
              
              {item?.stock||DEFAULT_VALUES.DOUBLE_DASH}
            </TableCell>
          );
          json["stock"] = (
            <TableCell className="ellipsis">
              <span>
                {item.warehouse_existing_stock || DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          );
          json["price"] = (
            <TableCell>
              &#8377;&nbsp;
              {item.Product?.mrp || DEFAULT_VALUES.DOUBLE_DASH}
            </TableCell>
          );
          json["status"] = (
            <TableCell className="ellipsis">
              <span>
                {item?.Product?.ProductStatus?.name || DEFAULT_VALUES.DOUBLE_DASH}
              </span>
            </TableCell>
          );
          json["old_stock"] = (
            <TableCell>
              {item?.warehouse_existing_stock || DEFAULT_VALUES.DOUBLE_DASH}
            </TableCell>
          );
          json["partial_qty"] = (
            <TableCell className="" style={{ width:"10%", maxWidth:"12%", minWidth:"10%", color: "#F95A3F", padding:" 0px 16px 0px 16px" }}>
               <CustomInput
                  formControlProps={{
                    fullWidth: true,
                    margin: "normal",
                    className: "add-screen-formcontrol mt-2",
                  }}
                  inputProps={{
                    inputProps:{
                      max:item?.stock||0,
                    },
                    disabled:!orderContainer?.some((order) => order.id === item.id && order.isChecked),
                    value:item.received_stock,
                    onChange: (event) => onChangeHandler(event, item.id, item.product_id),
                    name: `received_stock`,
                    disableNegativeValue: true,
                    className: "input-add-screen-small small-input ",
                    variant: "outlined",
                    type: "number",
                  }}
                />
            </TableCell>
          );
          json["stock_transfer"] = (
            <TableCell style={{ color: "#F95A3F" }}>
              -{item?.stock || DEFAULT_VALUES.DOUBLE_DASH}
            </TableCell>
          );
          json["checkbox"] =<TableCell>
            <Checkbox
          checked={
            orderContainer?.some((order) => order.id === item.id && order.isChecked)
          }
          value={
            orderContainer?.some((order) => order.id === item.id && order.isChecked)
          }
          size="small"
          classes={{
            root: "permission-checkbox",
            checked: "permission-checkbox-checked",
          }}
          onChange={(ev)=>handleRowCheckbox(ev,item)}
        />
        </TableCell>
  
          temp.push(json);
          totalOldStock += item?.warehouse_existing_stock;
          // totalReturnedStock += item?.stock;
        });
        temp.push({
          id: 0,
          sku: <TableCell />,
          name: <TableCell />,
          category: <TableCell />,
          transfer_qty:(
            <TableCell>
              <b>Total Stock</b>
            </TableCell>
          ),
           status: (
            <TableCell>
              <b>Total Stock</b>
            </TableCell>
          ),
          old_stock: (
            <TableCell>
              <b>{totalOldStock}</b>
            </TableCell>
          ),
          stock: (
            <TableCell>
              <b>{totalOldStock}</b>
            </TableCell>
          ),
          price: <TableCell />,
          partial_qty: <TableCell />,
          checkbox: <TableCell />,
        });
  
       return setTableData(temp)
    }
  },[orderContainer,dropdownSelectedProduct,currentOrderStatus,materialTransferView, location.state]) 

  useEffect(() => {
    if (!scanItemsToggle || currentOrderStatus?.key !== MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key) {
      setOrderContainer(materialTransferView.ShippingDetails);
      setUpdatedOrder([]);
    } else {
      setOrderContainer([]);
      setUpdatedOrder([]);
    }
  }, [scanItemsToggle]);

  useEffect(()=>{
    handleOrderStatusChange("event",location.state)
    },[location.state])
    
  useEffect(()=>{
    if(location.state&&materialTransferView.id&&currentOrderStatus?.key == MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key)
    {
      materialTransferView.ShippingDetails.forEach((obj)=>{
        obj.isChecked=true;
        obj.received_stock=obj.stock
      })
      setOrderContainer(materialTransferView.ShippingDetails);
    }
  },[location.state,materialTransferView,currentOrderStatus])

  const handleOrderStatusChange=(ev, value)=>{
    setCurrentOrderStatus(value)

    value?.key=="CANCELLED"&& setShowCancelModal(true);
    // value.key=="PARTIALLY_RECEIVED" && setShowPartialModal(true)
  }

  const handleDropdownSelectedProduct=(ev, newValue)=>{
    setOrderContainer((prev) => {
      const exists = prev?.some((item) => item.id === newValue.id);
      if (exists) {
        // Replace the existing object with the new one
        return prev?.map((item) => (item.id === newValue.id ? item : item));
      } else {
        // Add the new object to the array
        return [...prev, newValue];
      }
    });
    setDropdownSelectedProduct(newValue);
    if (newValue) {
      setTimeout(() => {
        setDropdownSelectedProduct(null); // Clears the input field
      }, 0);
    }
  }

  const handleScanItemsToggle=(checked)=>{
    setScanItemsToggle(checked)
  }

  const closeCancelModal=()=> {
    setCurrentOrderStatus(DEFAULT_ORDER_STATUS);
    return setShowCancelModal(false);
  }


  const partialStateHandler=()=>{
      return setShowPartialModal(false);
  }

  const closePartialModal=()=> {
    // setCurrentOrderStatus(DEFAULT_ORDER_STATUS);
    return setShowPartialModal(false);
  }

  const handlePopupCheckbox=(ev)=>{
     const {checked} =ev.target
      setPopupInputCheck(checked)
  }

  const submitHandler = async () => {
    const payload = {
      action: "manage.material_transfer",
      id: parseInt(match.params.id),
      new_status: currentOrderStatus?.key,
      ...(currentOrderStatus?.key === MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key && {
        items: orderContainer.reduce((acc, order) => {
          if (order?.received_stock) {
            acc.push({
              "product_id": order?.product_id,
              "received_stock": parseInt(order?.received_stock),
            });
          }
          return acc;
        }, []),
        create_partial_transfer_order: popupInputCheck,
      }),
    };
  
    const successMessages = {
      [MATERIAL_ORDER_STATUSES.RECEIVED.key]: "Order received successfully",
      [MATERIAL_ORDER_STATUSES.CANCELLED.key]: "Order Cancelled successfully",
    };
  
    const response = await postDashboardWebApi(
      getAccessToken(),
      API_ROUTES[API_ROUTES_KEY.GET_MATERIAL_TRANSFER],
      { payload }
    );
  
    if (webApiCheck(response)) {
      if (successMessages[currentOrderStatus?.key]) {
        successToast({ message: successMessages[currentOrderStatus?.key] });
      }
      history.push("/warehouse-orders");
    }
  };

    return (
      <>
        <Breadcrumbs data={breadcrumbsMapping(match.path, {})} />

        <CardContainer
          isBorderAvailable={true}
          title={`Material Transfer OverView [${materialTransferView?.source_warehouse?.name}]`}
        >
          <Grid container direction="row" className="mt-20">
            <Grid
              item
              xs={4}
              style={{ display: "flex", flexDirection: "column" }}
            >
              {/* <Grid container direction="column"> */}
              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Order Id:</label>
                <span className="name">
                  {materialTransferView?.order_id || DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Source:</label>
                <span>
                  {materialTransferView?.source_warehouse?.name ||
                    DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Created By:</label>
                <span>
                  {materialTransferView?.User?.first_name
                    ? `${materialTransferView?.User?.first_name} ${materialTransferView?.User?.last_name}`
                    : DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Date Created:</label>
                <span>
                  {getDateAndTime(materialTransferView?.created_at) ||
                    DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>
              {/* </Grid> */}
            </Grid>

            <Grid
              item
              xs={5}
              style={{ display: "flex", flexDirection: "column" }}
            >
              {/* <Grid container direction="column"> */}
              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Status:</label>
                <span
                  style={{
                    color:
                      REFILL_MANAGEMENT_STATUS[materialTransferView?.state]
                        ?.color,
                  }}
                >
                  {
                    REFILL_MANAGEMENT_STATUS[materialTransferView?.state]
                      ?.displayName
                  }
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Destination:</label>
                <span>
                  {materialTransferView?.destination_warehouse?.name ||
                    DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Stock Return:</label>
                <span>
                  {materialTransferView?.stock || DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>

              <Grid
                item
                lg={12}
                style={{ marginBottom: "0.8rem" }}
                className="view-top-details"
              >
                <label>Last Updated:</label>
                <span>
                  {getDateAndTime(materialTransferView?.updated_at) ||
                    DEFAULT_VALUES.DOUBLE_DASH}
                </span>
              </Grid>
              {/* </Grid> */}
            </Grid>

            <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                paddingBottom: "0.8rem",
              }}
              item
              xs={3}
            >
              <span>
                Select status to update order
                <span className="asterisk">*</span>
              </span>
              <CustomAutoComplete
                autoCompleteProps={{
                  id: "multiselect-purchase-order-manage",
                  options: Object.values(MATERIAL_ORDER_STATUSES),
                  fullWidth: true,
                  size: "small",
                  value: currentOrderStatus,
                  onChange: handleOrderStatusChange,
                  getOptionLabel: (option) =>
                    option && option.displayText ? option.displayText : "",
                  openOnFocus: true,
                  required: true,
                  style: {
                    width: "97%",
                  },
                }}
                textFieldProps={{
                  className: "input-add-screen mt-3",
                  variant: "outlined",
                  required: true,
                }}
              />
            </Grid>
          </Grid>

          <Grid item lg={1} md={6} sm={12} />
          {currentOrderStatus?.key ===
            MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key && (
            <div style={{ display: "flex" }}>
              <span style={{ marginTop: "0.4rem", color: "grey" }}>
                Select or scan the items for transfer orders
              </span>
              <NewCustomToggle
                inputProps={{
                  value: scanItemsToggle,
                  checked: scanItemsToggle,
                  onChange: (ev) => handleScanItemsToggle(ev.target.checked),
                  name: "scanItemsToggle",
                }}
              />
            </div>
          )}

          <Grid container>
            <Grid item lg={12} md={12} sm={12}>
              <div className="product-custom-table">
                <CustomNewTable
                  tableHead={
                    currentOrderStatus?.key !==
                    MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key
                      ? tableHead
                      : tableHeadChangeOrder
                  }
                  tableData={tableData}
                  refr={
                    currentOrderStatus?.key !==
                    MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key
                      ? "material-overview-table"
                      : "material-overview-qr-table"
                  }
                />
              </div>
            </Grid>
          </Grid>
        </CardContainer>

        <div style={{ display: "flex", marginTop: "2rem" }}>
          <div>
            <CustomButton
              type="button"
              btnProps={{
                variant: "contained",
                text: [
                  <img
                    src={CrossIcon}
                    alt="Cancel Icon Image"
                    className="view-button-icon"
                    key={0}
                  />,
                  "Cancel",
                ],
                className:
                  // "view-button-new view-button-new-hover view-button-save ml-4",
                  "view-button-new mb-4 ml-4 view-button-new-hover view-button-delete",
                onClick: () => history.goBack(),
              }}
            />
          </div>

          <div>
            <CustomButton
              type="button"
              btnProps={{
                text: ["Save"],
                variant: "contained",
                className:
                  "view-button-new view-button-new-hover view-button-save ml-4",
                style: { background: "red" },
                onClick:
                  currentOrderStatus?.key ===
                  MATERIAL_ORDER_STATUSES.PARTIALLY_RECEIVED.key
                    ? ()=> setShowPartialModal(true)
                    :
                    submitHandler
                    
              }}
            />
          </div>
        </div>

        <EditForm
          alertMessage={"You want to cancel this Transfer Order"}
          editButtonText={"Yes"}
          onClose={closeCancelModal}
          onEditForm={submitHandler}
          cancelButtonText={"No"}
          open={showCancelModal}
          newEditform={true}
          type={"Cancelled ?"}
          enableDangerousHTML
        />
        <EditForm
          alertMessage={
            <>
              <div>You want to partially receive the Transfer Order</div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  fontSize: "1rem",
                  justifyContent: "center",
                  margin: "2rem 0 1rem 0",
                }}
              >
                <input
                  checked={popupInputCheck}
                  onChange={(ev) => handlePopupCheckbox(ev)}
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                />
                Do you want to create a transfer order for the remaining
                quantity
              </div>
            </>
          }
          editButtonText={"Save"}
          onClose={closePartialModal}
          onEditForm={submitHandler}
          cancelButtonText={"Cancel"}
          open={showPartialModal}
          newEditform={true}
          type={"Confirmation"}
          // enableDangerousHTML
        />
      </>
    );
  
}

const mapStateToProps = (state) => ({
  materialTransferView: state.materialTransferView.data,
  otherParams: state.materialTransferView.others,
  me: state.meReducer.data,
});
const mapDispatchToProps = (dispatch) => ({
  requestMaterialTransfer: (urlEndPoint, payload) =>
    dispatch(requestMaterialTransfer(urlEndPoint, payload)),
  resetMaterialTransferOrder: () => dispatch(resetMaterialTransferOrder()),
  successToast: (obj) => dispatch(successToast(obj)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaterialTransferMangeView);
